import { z } from 'zod';

export const RegistrationFormSchema = z.object({
	email:     z.string().email('Invalid email'),
	firstName: z.string().min(1, 'First name is required'),
	lastName:  z.string().min(1, 'Last name is required'),
	password:  z.string().min(6, 'Password must be at least 6 characters long'),
});
export type RegistrationFormModel = z.infer<typeof RegistrationFormSchema>;
